<app-spinner-service *ngIf="!declaracao"></app-spinner-service>

<div class="detail-page-wrapper p-4" *ngIf="declaracao">
  <div class="detail-card">
    <div class="detail-header">
      <div class="header-icon"><i class="pi pi-file"></i></div>
      <div class="header-info">
        <h2 class="detail-title">Declaração Fiscal</h2>
        <p class="detail-subtitle" *ngIf="declaracao.declaracaoTransmitida?.idDeclaracao">
          Documento {{ obterNumeroDocumentoPorIdDeclaracao(declaracao.declaracaoTransmitida?.idDeclaracao) }}
          <span class="header-separator">·</span>
          Período {{ obterPeriodoApuracaoPorIdDeclaracao(declaracao.declaracaoTransmitida?.idDeclaracao) }}
        </p>
      </div>
    </div>

    <div class="resumo-valores" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores">
      <div class="valor-card valor-card--neutro" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.principal">
        <div class="valor-card__icon"><i class="pi pi-dollar"></i></div>
        <div class="valor-card__content">
          <span class="valor-card__label">Principal</span>
          <span class="valor-card__value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.principal | currency:'BRL' }}</span>
        </div>
      </div>
      <div class="valor-card valor-card--ir" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.juros">
        <div class="valor-card__icon"><i class="pi pi-percentage"></i></div>
        <div class="valor-card__content">
          <span class="valor-card__label">Juros</span>
          <span class="valor-card__value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.juros | currency:'BRL' }}</span>
        </div>
      </div>
      <div class="valor-card valor-card--negativo" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.multa">
        <div class="valor-card__icon"><i class="pi pi-exclamation-triangle"></i></div>
        <div class="valor-card__content">
          <span class="valor-card__label">Multa</span>
          <span class="valor-card__value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.multa | currency:'BRL' }}</span>
        </div>
      </div>
      <div class="valor-card valor-card--liquido" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.total">
        <div class="valor-card__icon"><i class="pi pi-wallet"></i></div>
        <div class="valor-card__content">
          <span class="valor-card__label">Total</span>
          <span class="valor-card__value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.valores?.total | currency:'BRL' }}</span>
        </div>
      </div>
    </div>

    <div class="info-section" *ngIf="declaracao.declaracaoTransmitida">
      <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações da Declaração</span></div>
      <div class="detail-grid">
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.dataHoraTransmissao">
          <div class="detail-label"><i class="pi pi-calendar"></i><span>Data Transmissão</span></div>
          <div class="detail-value">{{ formatarDataTransmissao(declaracao.declaracaoTransmitida?.dataHoraTransmissao) }}</div>
        </div>
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.dataVencimento">
          <div class="detail-label"><i class="pi pi-calendar-times"></i><span>Data Vencimento</span></div>
          <div class="detail-value">{{ formatarDataVencimento(declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.dataVencimento) }}</div>
        </div>
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.dataLimiteAcolhimento">
          <div class="detail-label"><i class="pi pi-calendar-check"></i><span>Data Limite Acolhimento</span></div>
          <div class="detail-value">{{ formatarDataVencimento(declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.dataLimiteAcolhimento) }}</div>
        </div>
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao1">
          <div class="detail-label"><i class="pi pi-comment"></i><span>Observação 1</span></div>
          <div class="detail-value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao1 }}</div>
        </div>
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao2">
          <div class="detail-label"><i class="pi pi-comment"></i><span>Observação 2</span></div>
          <div class="detail-value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao2 }}</div>
        </div>
        <div class="detail-item" *ngIf="declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao3">
          <div class="detail-label"><i class="pi pi-comment"></i><span>Observação 3</span></div>
          <div class="detail-value">{{ declaracao.declaracaoTransmitida?.detalhamentoDarfMaed?.observacao3 }}</div>
        </div>
      </div>
    </div>

    <div class="info-section" *ngIf="declaracao.declaracaoTransmitida?.valoresDevidos?.length">
      <div class="section-title"><i class="pi pi-list"></i><span>Valores Devidos</span></div>
      <p-table [value]="declaracao.declaracaoTransmitida?.valoresDevidos || []" styleClass="detail-table">
        <ng-template pTemplate="header">
          <tr>
            <th>Tributo</th>
            <th>Valor</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr *ngIf="item.valor">
            <td>{{ obterDescricaoTributo(item.codigoTributo) }}</td>
            <td>{{ item.valor | currency:'BRL' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="info-section" *ngIf="declaracao.declaracaoTransmitida">
      <div class="section-title"><i class="pi pi-download"></i><span>Documentos</span></div>
      <div class="detail-actions">
        <p-button *ngIf="declaracao.declaracaoTransmitida?.darf" label="Baixar DARF" icon="pi pi-download" (onClick)="baixarPdf(declaracao.declaracaoTransmitida?.darf, 'darf')" class="p-button-success"></p-button>
        <p-button *ngIf="declaracao.declaracaoTransmitida?.declaracao" label="Baixar Declaração" icon="pi pi-download" (onClick)="baixarPdf(declaracao.declaracaoTransmitida?.declaracao, 'declaracao')" class="p-button-success"></p-button>
        <p-button *ngIf="declaracao.declaracaoTransmitida?.notificacaoMaed" label="Baixar Notificação" icon="pi pi-download" (onClick)="baixarPdf(declaracao.declaracaoTransmitida?.notificacaoMaed, 'notificacaoMaed')" class="p-button-success"></p-button>
        <p-button *ngIf="declaracao.declaracaoTransmitida?.recibo" label="Baixar Recibo" icon="pi pi-download" (onClick)="baixarPdf(declaracao.declaracaoTransmitida?.recibo, 'recibo')" class="p-button-success"></p-button>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <p-button label="Voltar" icon="pi pi-arrow-left" (click)="voltar()" class="p-button-secondary"></p-button>
  </div>
</div>
